import type { EditorRootState } from "@v1/store/store";

import { keepPreviousData, skipToken } from "@tanstack/react-query";
import { useEditorSelector } from "@v1/store/store";
import { elementRouter } from "@v2/trpc/routes/element";

// NOTE (Patrick, 2026-02-20): Use the raw draftElementId from Redux state
// rather than the derived `selectDraftElementId` selector. The derived selector
// returns undefined when the element isn't in the mapping yet (e.g. during page
// creation before the element is fully loaded), which causes the query to use
// `skipToken` and disables `keepPreviousData`. Using the raw ID ensures the
// query stays active with a valid key during transitions, so
// `keepPreviousData` can properly bridge the gap and prevent the UI from
// flashing a skeleton (which detaches the element-page-title button from the
// DOM and breaks E2E tests in React 19).
const selectRawDraftElementId = (state: EditorRootState) => {
  return state.core.elements.draftElementId;
};

export function useDraftElementMetadata() {
  const draftElementId = useEditorSelector(selectRawDraftElementId);
  const { data: elementMetadata } =
    elementRouter.getElementMetadataById.useQuery(draftElementId ?? skipToken, {
      placeholderData: keepPreviousData,
    });

  return elementMetadata;
}
